import React from 'react';
import Header from './Components/Header';
import Instructions from './Components/Instructions';

function InvitationLink(): React.JSX.Element {
    return (
        <div className="border-border bg-card flex flex-col gap-2.5 rounded-xl border p-5">
            <Header />
            <Instructions />
        </div>
    );
}

export default InvitationLink;
